import styled, { css } from "styled-components";
import { StyleVariant } from "../AmorgMenuTypes";
import { colors } from "../../colors/color";
import { assertNever } from "../../../amorg-common";

type BaseButtonProps = {
    selected:boolean, 
    styleVariant:StyleVariant, 
    isHovering:boolean
}

export const BaseButton = styled.button<BaseButtonProps>`
    position:relative;
    background:none;
    min-height:40px;
    width:100%;
    border:none;

    cursor:${props => props.isHovering ? 'pointer' : 'default'};

    ${props => props.selected && css`
        background:${colors.menu.backgroundSelected};
        border-radius: 4px;
    `}

    ${props => !props.selected && props.onClick && props.isHovering && css<{styleVariant:StyleVariant}>`
        border-radius: 4px;
       
        ::after {
            content:'';
            display:block;
            position: absolute;
            border-radius: 4px;
            top:0;
            right:0;
            bottom:0;
            left:0;  
            opacity:0.5;
            background: ${ (props) => {
                switch (props.styleVariant) {
                    case "default":
                        return `${colors.menu.default.backgroundHover}`;
                    case "emphasized":
                        return `${colors.menu.emphasized.backgroundHover}`;
                    case "destructive":
                            return `${colors.menu.destructive.backgroundHover}`;
                    case "strike-through":
                        return `${colors.menu.strikeThrough.backgroundHover}`;
                    default: assertNever(props.styleVariant);
                }
            }};
        }
    `}
`;